export default {
  path: '/center',
  name: 'Center',
  redirect: '/center/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/center'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/center/info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'squadDetail',
      component: () => import('@/views/squad/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'setting',
      component: () => import('@/views/center/setting'),
      meta: { requiresAuth: true }
    },
    {
      path: 'infoViewExpert',
      component: () => import('@/views/center/infoViewExpert'),
      meta: { requiresAuth: true }
    },
  ]
}
